let config = null

export const loadConfig = async () => { 
  if (!config) {    
    if (process.env?.NODE_ENV !== 'development') {
      const response = await fetch('/config/app-config.json')     
      config = await response.json()            
    } else {
      config = {
        VUE_APP_FULL_URL_API: process.env.VUE_APP_FULL_URL_API,
        VUE_APP_RECAPTCHA_KEY: process.env.VUE_APP_RECAPTCHA_KEY,
        VUE_APP_ECOMMERCE_IMAGES_URL: process.env.VUE_APP_ECOMMERCE_IMAGES_URL
      }     
    }
  }
  return config
}

export const getConfig = async () => {
  if (!config) {
    await loadConfig()
  }
  return config
}